module.exports = "/images/menu-help.svg?373a9184b231a68d01e768869aa8a079";